export { default } from "./TeachersTab";
